import { Base } from "../../framework/base";
var NumberTitle = /** @class */ (function () {
    function NumberTitle(obj) {
        this.number = obj && obj.number || 0;
        this.title = obj && obj.title || "";
    }
    NumberTitle.createNumberTitle = function (number, title) {
        var result = new NumberTitle();
        result.number = number;
        result.title = title;
        return result;
    };
    NumberTitle.getTitleByNumber = function (num, items) {
        if (Base.isNullOrUndefined(num) || !items || items.length < 1)
            return "";
        var item = items.find(function (i) { return Base.equalInt(i.number, num); });
        return item ? item.title : "";
    };
    return NumberTitle;
}());
export { NumberTitle };
